import { MutationUpdaterFn } from '@apollo/client'
import {
  DeleteAllNotificationMutation,
  GqlNotificationListDocument,
  GqlNotificationListQuery,
  GqlNotificationListQueryVariables,
} from 'generated/graphql'

// import {
//   DeleteAllNotificationMutation,
//   GqlNotificationListDocument,
//   GqlNotificationListQuery,
//   GqlNotificationListQueryVariables,
// } from 'generated/graphql'

const removeAllScrapUpdator =
  (
    variables: GqlNotificationListQueryVariables,
  ): MutationUpdaterFn<DeleteAllNotificationMutation> =>
  (cache) => {
    // delete data
    const cachedNotifications = cache.readQuery<GqlNotificationListQuery>({
      query: GqlNotificationListDocument,
      variables: variables,
    })

    if (!cachedNotifications || !cachedNotifications.viewerNotifications) return
    cache.writeQuery({
      query: GqlNotificationListDocument,
      variables: variables,
      data: {
        ...cachedNotifications,
        viewerNotifications: {
          ...cachedNotifications.viewerNotifications,
          nodes: [],
        },
      },
    })
  }

export default removeAllScrapUpdator
